function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "preview-letter");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19.19,
    height: 20.93,
    viewBox: "0 0 19.19 20.93"
  }, props), _ref, React.createElement("g", null, React.createElement("path", {
    d: "M13.53,12,6.32,7.81,9.38,2.52l7.2,4.16ZM7.1,7.6l6.22,3.58L15.8,6.89,9.58,3.3Z",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M19.19,6.19,8.48,0,0,14.69l8.65,5H.51v1.25H16.9V19.68H11.4ZM1.13,14.38,8.78,1.13l9.28,5.36L10.44,19.68h-.13Z",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("rect", {
    x: 8.49,
    y: 7.93,
    width: 0.71,
    height: 7.85,
    transform: "translate(-5.84 13.59) rotate(-60)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("rect", {
    x: 7.47,
    y: 9.67,
    width: 0.71,
    height: 7.85,
    transform: "translate(-7.86 13.57) rotate(-60)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("rect", {
    x: 6.37,
    y: 11.46,
    width: 0.71,
    height: 7.85,
    transform: "translate(-9.96 13.52) rotate(-60)",
    style: {
      "fill": "#fff"
    }
  })));
};

export default __webpack_public_path__ + "static/media/preview-letter.57982c16.svg";
export { SvgComponent as ReactComponent };